import { container, title } from 'assets/jss/material-kit-react.js'
import { successColor } from 'assets/jss/material-kit-react'
import { primaryColor } from 'assets/jss/material-kit-react'

const culturePageStyle = {
  container: {
    zIndex: '12',
    color: '#FFFFFF',
    ...container,
  },
  title: {
    fontSize: '4.2rem',
    fontWeight: '600',
    display: 'inline-block',
    position: 'relative',
  },
  subtitle: {
    ...title,
    display: 'inline-block',
    position: 'relative',
    marginTop: '-15px',
    color: '#FFFFFF',
    textDecoration: 'none',
    fontSize: '1.8rem',
    // maxWidth: '500px',
    // margin: '10px auto 0',
  },
  navButton: {
    color: 'inherit',
    '&:hover,&:focus': {
      color: 'inherit',
    },
  },
  main: {
    background: '#FFFFFF',
    position: 'relative',
    zIndex: '3',
  },
  mainRaised: {
    margin: '-60px 30px 0px',
    borderRadius: '6px',
    boxShadow: '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    '@media (max-width: 830px)': {
      'margin-left': '10px',
      'margin-right': '10px',
    },
    '@media (max-width: 576px)': {
      'margin-top': '-30px',
    },
  },
  leftImg: {
    marginTop: '70px',
    marginLeft: '30px',
  },
  listRoot: {
    width: '100%',
    maxWidth: 400,
  },
  listIcon: {
    marginTop: '20px',
    fill: successColor,
  },
  listTextHeader: {
    color: 'black',
    fontWeight: '600',
  },
  containerTitle: {
    fontSize: '3rem',
    fontWeight: '600',
    textAlign: 'center',
    color: 'black',
  },
  cardIcon: {
    fill: primaryColor,
    width: '100px',
    textAlign: 'center',
    margin: '0 auto',
  },
  cardTitle: {
    fontWeight: '500',
    textAlign: 'center',
    fontSize: '25px',
  },
  description: {
    '& p': {
      fontSize: '18px',
      width: '110px',
      margin: '0 auto',
    },
  },
}

export default culturePageStyle
